/**
 * Environment detection utilities for Vite applications
 */

/**
 * Check if the application is running in production environment
 * @returns true if VITE_ENV is 'PROD' (case-insensitive), false otherwise
 */
export const isProdEnvironment = (): boolean => {
    return import.meta.env.VITE_ENV?.trim().toUpperCase() === 'PROD';
};

/**
 * Check if the application is running in development environment
 * @returns true if VITE_ENV is 'DEV' (case-insensitive), false otherwise
 */
export const isDevEnvironment = (): boolean => {
    return import.meta.env.VITE_ENV?.trim().toUpperCase() === 'DEV';
};

/**
 * Check if the application is running in local environment
 * @returns true if VITE_ENV is 'LOCAL' (case-insensitive), false otherwise
 */
export const isLocalEnvironment = (): boolean => {
    return import.meta.env.VITE_ENV?.trim().toUpperCase() === 'LOCAL';
};

/**
 * Get the current environment name (normalized)
 * @returns Normalized environment name ('PROD', 'DEV', 'LOCAL') or 'UNKNOWN'
 */
export const getEnvironment = (): 'PROD' | 'DEV' | 'LOCAL' | 'UNKNOWN' => {
    const env = import.meta.env.VITE_ENV?.trim().toUpperCase();
    if (env === 'PROD' || env === 'DEV' || env === 'LOCAL') {
        return env;
    }
    return 'UNKNOWN';
};
